import { useState } from 'react'

import Divider from '@mui/material/Divider'
import Popover from '@mui/material/Popover'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@components/_mui/Typography'

import PagesHistoryFlaggedTab from './PagesHistoryFlaggedTab'
import PagesHistoryItemsTab from './PagesHistoryItemsTab'

export default function PagesHistoryPopover({ anchorEl, open = false, onClose }) {
  const [tab, setTab] = useState('all')

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      slotProps={{
        paper: {
          sx: { width: '400px' },
          'data-testid': 'page-history-paper',
        },
      }}
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2 }}>
        <Typography variant="h4">History</Typography>
      </Stack>
      <Tabs value={tab} onChange={(e, tab) => setTab(tab)} sx={{ px: 2 }}>
        <Tab label="All" value="all" data-testid="history-all-tab" />
        <Tab label="Flagged" value="flagged" data-testid="history-flagged-tab" />
      </Tabs>
      <Divider />
      {tab === 'all' && <PagesHistoryItemsTab onClose={onClose} />}
      {tab === 'flagged' && <PagesHistoryFlaggedTab onClose={onClose} />}
    </Popover>
  )
}
